import {ExtraData} from '@/store/modules/issue/types'

const initExtraData: ExtraData = {
  cash: 0,
  checkBill: 0,
  note: 0,
  credit: 0,
  remark: '',
  purposeType: '청구',
}

export {initExtraData}
